// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__v4oJQ","colMin":"styles_colMin__1ZJ0J","colCheckbox":"styles_colCheckbox__deB_B"};